export default [

  // Devices
  {
    path: '/devices',
    name: 'devices',
    component: () => import('@/views/devices/List.vue'),
    meta: {
      resource: 'Tech',
      action: 'read',
    },
  },
  {
    path: '/devices/:id/:data',
    name: 'device',
    component: () => import('@/views/devices/DeviceDetails.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
  // Models
  {
    path: '/models',
    name: 'models',
    component: () => import('@/views/model_devices/List.vue'),
    meta: {
      resource: 'Tech',
      action: 'read',
    },
  },
  // Connections
  {
    path: '/connections',
    name: 'connections',
    component: () => import('@/views/cloud_connections/List.vue'),
    meta: {
      resource: 'Tech',
      action: 'read',
    },
  },
  // Unit of measurement
  {
    path: '/units',
    name: 'units',
    component: () => import('@/views/unit_measurement/List.vue'),
    meta: {
      resource: 'Tech',
      action: 'read',
    },
  },
  // Places installed devices
  {
    path: '/sites',
    name: 'sites',
    component: () => import('@/views/organizations/List.vue'),
    meta: {
      resource: 'Tech',
      action: 'read',
    },
  },
  // Users
  {
    path: '/users',
    name: 'users',
    // component: () => import('@/views/users/List.vue'),
    component: () => import('@/views/users/List.vue'),
    meta: {
      resource: 'User',
      action: 'read',
    },
  },
]
